import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
const Zendesk = _ref => {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.238 8.002v11.154H2l9.238-11.154Zm0-4.002A4.62 4.62 0 0 1 2 4h9.238Zm1.522 15.157a4.619 4.619 0 0 1 9.238 0H12.76Zm0-4.003V4H22l-9.24 11.153v.001Z",
    fill: color
  }));
};
export default Zendesk;